import React, { FC } from 'react';
import { Box, Circle, Flex } from '@chakra-ui/react';

import SunshineIcon from 'components/_core/SunshineIcon';
import Text from 'components/_core/Text';
import OnboardingFullPage from 'features/Onboarding/components/OnboardingFullPage';

import { State } from '../../machine';
import TopBar, { MOBILE_HEADER_HEIGHT } from './components/TopBar';

export { MOBILE_HEADER_HEIGHT, default as TopBar } from './components/TopBar';

interface StepsLayoutProps {
  currentState: State;
  children: React.ReactNode;
  onClose: () => void;
  onPrev: () => void;
}

const getStepStyle = (index: number, currentStepIndex: number) => {
  if (index === currentStepIndex) {
    return {
      backgroundColor: 'grey.800',
      color: 'white',
    };
  }

  if (index < currentStepIndex) {
    return {
      backgroundColor: 'green.300',
    };
  }

  return {
    backgroundColor: 'white',
    border: '1px solid',
    borderColor: 'grey.400',
    color: 'grey.800',
  };
};

const STEPS = [
  {
    label: 'Forfait création SASU',
    state: State.CREATION_PRESENTATION,
  },
  {
    label: 'Offre Compte Pro',
    state: State.PLAN_SELECTION,
  },
  {
    label: 'Récapitulatif',
    state: State.PACKAGE_RECAP,
  },
  {
    label: 'Paiement',
    state: State.PACKAGE_PAYMENT,
  },
];

const StepsLayout: FC<StepsLayoutProps> = ({
  children,
  currentState,
  onClose,
  onPrev,
}) => {
  const currentStepIndex = STEPS.findIndex(
    (step) => step.state === currentState,
  );

  return (
    <OnboardingFullPage key={currentState}>
      <TopBar onClose={onClose} onPrev={onPrev}>
        <Flex
          alignItems="center"
          flexDirection="column"
          marginTop={{
            base: MOBILE_HEADER_HEIGHT,
            lg: '4rem',
          }}
          width="100vw"
        >
          <Box
            maxWidth="972px"
            paddingLeft="space-16"
            paddingRight="space-16"
            width="100%"
          >
            <Flex
              display={{
                base: 'none',
                lg: 'flex',
              }}
              marginBottom="space-56"
              marginTop="space-32"
            >
              {STEPS.map(({ label, state }, index) => (
                <Flex alignItems="center" key={state}>
                  {index > 0 ? (
                    <Box
                      background="grey.400"
                      height={1}
                      marginLeft="space-8"
                      marginRight="space-8"
                      width="16px"
                    />
                  ) : null}
                  <Circle
                    {...getStepStyle(index, currentStepIndex)}
                    alignItems="center"
                    display="flex"
                    justifyContent="center"
                    lineHeight="1.5"
                    marginRight="space-8"
                    size="space-24"
                  >
                    {index < currentStepIndex ? (
                      <SunshineIcon
                        color="grey.800"
                        name="tick"
                        size="icon-13"
                      />
                    ) : (
                      <Text color="inherit" fontSize="font-13" lineHeight={1}>
                        {index + 1}
                      </Text>
                    )}
                  </Circle>
                  <Text
                    variant={
                      index === currentStepIndex ? 'primary' : 'secondary'
                    }
                  >
                    {label}
                  </Text>
                </Flex>
              ))}
            </Flex>
          </Box>
          {children}
        </Flex>
      </TopBar>
    </OnboardingFullPage>
  );
};

export default StepsLayout;
